 
import JobBreadcrumb from "../../commonComponents/breadcrumbs/JobBreadcrumb";
import JobDetail from "../../commonComponents/productDetail/JobDetail";

const JobDetail3Container = () => {
  return (
    <>
      <JobBreadcrumb type="style_3" />
      <JobDetail detailType="style_3" />
    </>
  );
};

export default JobDetail3Container;
